// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__x693w","default":"Textarea_default__JLwLQ","fullWidth":"Textarea_fullWidth__DWdrB","noResize":"Textarea_noResize__1rbQJ"};